import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstensioniComponent } from './estensioni.component'
import { CustomMaterialModule } from '../../material-module/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EstensioneService } from 'src/app/services/estensione.service';
import { IntegrazioneGeneraliComponent } from './integrazione-generali/integrazione-generali.component';
import { IntegrazioneAllianzComponent } from './integrazione-allianz/integrazione-allianz.component';
import { IntegrazioneGroupamaComponent } from './integrazione-groupama/integrazione-groupama.component';
import { IntegrazioneZurichComponent } from './integrazione-zurich/integrazione-zurich.component';
import { EstensioniMappaComponent } from './estensioni-mappa/estensioni-mappa.component';
import { DisabledIncaricatoAccertatoreComponent } from './disabled-incaricato-accertatore/disabled-incaricato-accertatore.component';
import { DeepPropertyComponent } from './deep-property/deep-property.component';
import { IntegrazioneRealeComponent } from './integrazione-reale/integrazione-reale.component';
import { IntegrazioneUnipolComponent } from './integrazione-unipol/integrazione-unipol.component';
import { IntegrazioneItasComponent } from './integrazione-itas/integrazione-itas.component';
import { ChatAgenziaLiquidatoreExtComponent } from './chat-agenzia-liquidatore/chat-agenzia-liquidatore.component';
import { EntityPickersModule } from 'src/app/shared/custom-form-controls/entity-pickers/entity-pickers.module';



@NgModule({
  declarations: [EstensioniComponent, IntegrazioneGeneraliComponent, IntegrazioneAllianzComponent, IntegrazioneGroupamaComponent, IntegrazioneZurichComponent, IntegrazioneItasComponent, EstensioniMappaComponent, DisabledIncaricatoAccertatoreComponent, DeepPropertyComponent, IntegrazioneRealeComponent, IntegrazioneUnipolComponent, ChatAgenziaLiquidatoreExtComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    EntityPickersModule,
  ],
  exports: [
    EstensioniComponent
  ]
})
export class EstensioniModule { }
